import { ref } from 'vue'
import { API_BASE } from '@/config'

export interface BlockGrid {
  blockId: string
  maxBay: number
  maxRow: number
}

export function useSlotGrid() {
  const grids = ref<BlockGrid[]>([])
  const isLoading = ref(false)
  const error = ref<string | null>(null)

  async function fetchAll(): Promise<void> {
    isLoading.value = true
    error.value = null
    try {
      const resp = await fetch(`${API_BASE}/api/tos/slots`)
      if (!resp.ok) throw new Error(`HTTP ${resp.status}`)
      grids.value = await resp.json()
    } catch (e) {
      error.value = e instanceof Error ? e.message : 'Lỗi kết nối TOS'
    } finally {
      isLoading.value = false
    }
  }

  return { grids, isLoading, error, fetchAll }
}
